import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../public/icons/processV2.svg'
import _imports_1 from '../../public/icons/journalsV2.svg'
import _imports_2 from '../../public/icons/explorerV2.svg'
import _imports_3 from '../../public/icons/matching/matchingV2.svg'
import _imports_4 from '../../public/icons/metadataV2.svg'
import _imports_5 from '../../public/icons/maintenanceV2.svg'
import _imports_6 from '../../public/icons/dataV2.svg'
import _imports_7 from '../../public/icons/usersV2.svg'
import _imports_8 from '../../public/icons/logV2.svg'
import _imports_9 from '../../public/icons/infoV2.svg'
import _imports_10 from '../../public/icons/double_right_arrow.svg'
import _imports_11 from '../../public/icons/double_left_arrow.svg'
import _imports_12 from '../../public/icons/explorer/context_menu/open.svg'


const _hoisted_1 = { class: "end-user-category" }
const _hoisted_2 = { class: "sidebar-button" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "sidebar-button" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "sidebar-button" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "sidebar-button" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "configuration-category" }
const _hoisted_11 = { class: "sidebar-button" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "sidebar-button" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "sidebar-button" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "sidebar-button" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "system-category" }
const _hoisted_20 = { class: "sidebar-button" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "sidebar-button" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "sidebar-button" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "sidebar-button" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "sidebar-footer" }
const _hoisted_30 = ["title"]
const _hoisted_31 = {
  key: 0,
  src: _imports_10,
  class: "collapse-icon",
  alt: "Expand"
}
const _hoisted_32 = {
  key: 1,
  src: _imports_11,
  class: "collapse-icon",
  alt: "Collapse"
}
const _hoisted_33 = ["Key", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "sidebar",
    class: _normalizeClass({ collapsed: _ctx.isCollapsed })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.UserCanAccessWorkflow)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: `${_ctx.getDefaultWorkflowRoute()}` },
            title: _ctx.Localizer.Localize('Sidebar_Workflow')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  src: _imports_0,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Workflow")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessJournals && _ctx.FeatureFlagJournals)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: `${_ctx.getDefaultJournalEntriesRoute()}` },
            title: _ctx.Localizer.Localize('Sidebar_Journals')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Journals")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: { name: _ctx.RouteNames.ExplorerRoute },
        title: _ctx.Localizer.Localize('Sidebar_Explore')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("img", {
              src: _imports_2,
              class: "size-sm"
            }, null, -1)),
            (!_ctx.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Explore")), 1))
              : _createCommentVNode("", true),
            (_ctx.Tabs.length > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "counter",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setShowWindowsContextMenu($event)), ["prevent","stop"]))
                }, _toDisplayString(_ctx.Tabs.length), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["to", "title"]),
      (_ctx.FeatureFlagMatching && _ctx.UserCanAccessMatching)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: { name: `${_ctx.RouteNames.MatchingUI}` },
            title: _ctx.Localizer.Localize('Sidebar_Matching')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _cache[6] || (_cache[6] = _createElementVNode("img", {
                  src: _imports_3,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Matching")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.UserCanAccessModels)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: String(_ctx.modelsRoute) },
            title: _ctx.Localizer.Localize('Sidebar_Models')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _cache[7] || (_cache[7] = _createElementVNode("img", {
                  src: _imports_4,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Models")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessMaintenance)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: `${_ctx.getDefaultMaintenanceRoute()}` },
            title: _ctx.Localizer.Localize('Sidebar_Maintenance')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _cache[8] || (_cache[8] = _createElementVNode("img", {
                  src: _imports_5,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Maintenance")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessConfiure)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: { name: String(_ctx.configureRoute) },
            title: _ctx.Localizer.Localize('Sidebar_Configuration')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _cache[9] || (_cache[9] = _createElementVNode("img", {
                  src: _imports_6,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Configuration")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessSecurity)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: { name: String(_ctx.securityRoute) },
            title: _ctx.Localizer.Localize('Sidebar_Security')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _cache[10] || (_cache[10] = _createElementVNode("img", {
                  src: _imports_7,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Security")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_ctx.UserCanAccessAudit && _ctx.FeatureFlagAuditModule)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: `${_ctx.RouteNames.AuditRoute}` },
            title: _ctx.Localizer.Localize('Sidebar_Audit')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _cache[11] || (_cache[11] = _createElementVNode("img", {
                  src: _imports_8,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Audit")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessLogs)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: String(_ctx.logsRoute) },
            title: _ctx.Localizer.Localize('Sidebar_Logs')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _cache[12] || (_cache[12] = _createElementVNode("img", {
                  src: _imports_8,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Logs")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessAbout != null)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: { name: String(_ctx.aboutRoute) },
            title: _ctx.Localizer.Localize('Sidebar_About')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _cache[13] || (_cache[13] = _createElementVNode("img", {
                  src: _imports_9,
                  class: "size-sm"
                }, null, -1)),
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.Localizer.Localize("Sidebar_About")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HomeExtensions, (item, i) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        to: { name: _ctx.RouteNames.HomeExtensionRoute, params: { id: item.id } },
        title: item.caption
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("img", {
              src: item.svg,
              class: "size-sm"
            }, null, 8, _hoisted_27),
            (!_ctx.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(item.caption), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, 1032, ["to", "title"]))
    }), 256)),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", {
        class: "collapse-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args))),
        title: _ctx.isCollapsed ? 'Expand' : 'Collapse'
      }, [
        (_ctx.isCollapsed)
          ? (_openBlock(), _createElementBlock("img", _hoisted_31))
          : (_openBlock(), _createElementBlock("img", _hoisted_32))
      ], 8, _hoisted_30)
    ]),
    (_ctx.ShowWindowsContextMenu)
      ? (_openBlock(), _createBlock(_component_ContextMenu, {
          key: 0,
          TriggerEvent: _ctx.ShowWindowsContextMenu,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ShowWindowsContextMenu = null))
        }, {
          buttons: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (tab) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "context_menu_btn",
                Key: tab.Key,
                onClick: ($event: any) => (_ctx.Open(tab))
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("img", {
                  class: "theme-svg",
                  src: _imports_12
                }, null, -1)),
                _createTextVNode("  " + _toDisplayString(tab.Name), 1)
              ], 8, _hoisted_33))
            }), 256))
          ]),
          _: 1
        }, 8, ["TriggerEvent"]))
      : _createCommentVNode("", true)
  ], 2))
}